/**
 * ч.1218: «не проведено за задумом» для списків на DataTable (клієнтський список):
 * повертає ті самі рядки з `_unposted_note` — його читає нормалізована колонка «проведено»
 * (docStatusCols). Для списків із серверною пагінацією це робить useInfiniteGridDatasource.
 */
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchUnpostedNotes, unpostedCandidates } from '@/shared/utils/unpostedNotes';

export function useUnpostedNotes<T extends { id: string }>(documentType: string, rows: T[]): T[] {
  const ids = useMemo(() => unpostedCandidates(rows, documentType).get(documentType) ?? [], [rows, documentType]);
  const q = useQuery({
    queryKey: ['unposted-notes', documentType, ids],
    queryFn: () => fetchUnpostedNotes(documentType, ids),
    enabled: ids.length > 0,
    staleTime: 60_000,
  });
  return useMemo(() => {
    const notes = q.data;
    if (!notes) return rows;
    return rows.map((r) => (notes[r.id] ? { ...r, _unposted_note: notes[r.id]!.text } : r));
  }, [rows, q.data]);
}
